import { useEffect, useMemo, useState } from 'react';
import { SelectPickerOptionProps } from '@cp/src/components/Dropdown/interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useDispatch } from 'react-redux';
import { getAllocationStatus, getAllocationSummary } from './action';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { useNavigate } from 'react-router-dom';
import Dropdown from '@cp/src/components/Dropdown';
import APP_ROUTES from '@cp/src/layout/Routes';
import styles from './index.module.scss';
import { convertObjectToDropdownOptions } from './utils';
import { CollectionType } from './consts';

const AllocationStatus = () => {
  const [selectedCycle, setSelectedCycle] = useState<string>('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllocationStatus(CollectionType.TELE));
  }, []);

  const configData = useSelector((state: RootState) => state.allocations?.configData);

  const cycleOptions = useMemo(
    () => convertObjectToDropdownOptions(configData as Record<string, string>),
    [configData]
  );

  const handleOnChange = (selectedOption: SelectPickerOptionProps) => {
    const cycleValue = selectedOption?.value as string;
    setSelectedCycle(cycleValue);
    dispatch(getAllocationSummary(cycleValue, CollectionType.TELE));
    const searchParams = new URLSearchParams({ cycle: cycleValue });
    navigate(`${APP_ROUTES.SYSTEM_ALLOCATION_STATUS.path}?${searchParams.toString()}`);
  };

  return (
    <div className={styles.mainContainer}>
      <Typography variant="h2" className="mb-4">
        View allocation status for
      </Typography>

      <Dropdown
        placeholder="Select cycle"
        options={cycleOptions}
        selectedValue={selectedCycle}
        onSelectionChange={handleOnChange}
        containerClasses={'w-[200px]'}
      />
    </div>
  );
};

export default AllocationStatus;
